import RemoveIcon from 'react-icons/lib/md/delete';
import styled from 'styled-components';

import React, {Component} from 'react';

import DeleteModal from '../DeleteModal';

const Wrapper = styled.div`
  display: inline-block;
  margin: 15px;
  position: relative;
  border-width: 4px;
  border-style: solid;
  border-color: transparent;
  ${({isSelected}) =>
    isSelected &&
    `
  border-color: #4F3B91;
  `} user-select: none;
  cursor: pointer;
  width: 150px;
  height: 100px;
  overflow: hidden;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px;
  color: white;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.3);
`;

export default class extends Component {
  state = {deleteModalOpen: false};

  onDeleteConfirm = () => {
    this.setState({deleteModalOpen: false});
    this.props.onDelete();
  };

  openDeleteModal = (event) => {
    event.stopPropagation();
    this.setState({deleteModalOpen: true});
  };

  render() {
    return (
      <Wrapper {...this.props}>
        {/*
        <IconWrapper onClick={this.openDeleteModal}>
          <RemoveIcon />
        </IconWrapper>
        */}
        <DeleteModal
          onCancel={() => this.setState({deleteModalOpen: false})}
          onConfirm={this.onDeleteConfirm}
          open={this.state.deleteModalOpen}
        />
        {this.props.children}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/MediaPicker/Item.js